import classNames from 'classnames';
import EcoIconArr from 'eco-design-micro/icons/eco-icon-arrow';
import { BtnThreeProps } from 'eco-design-micro/props/btn/BtnThreeProps';
import { ImgHeightProps, ThemeWBProps } from 'eco-design-micro/props/const';
import { DataLayerProps } from 'eco-design-micro/props/DataLayerProps';
import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import { SectionTextWithColorProps } from 'eco-design-micro/props/msg/SectionTextProps';
import gtm from 'eco-design-reliance/gtm';
import EcoButtonThree from 'eco-design/base/eco-button-three';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import React, { useState } from 'react';
import './index.scss';

export interface EcoFaqWithImgItemProps extends ImgVideoProps, SectionTextWithColorProps, BtnThreeProps {}
export interface EcoFaqWithImgProps {
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 图片容器高度
     *
     * 5-3
     *
     * 1-1
     *
     * 4-3
     *
     * 16-9
     */
    imgHeight?: ImgHeightProps;
    /**
     * 列表选项
     */
    items: EcoFaqWithImgItemProps[];
    /**
     * 样式名
     */
    className?: string;
    /**
     * tab 切换的埋点
     */
    dataLayerTab?: DataLayerProps;
}

const EcoFaqWithImg: React.FC<EcoFaqWithImgProps> = ({ dataLayerTab, className, theme, imgHeight = '1-1', items = [] }) => {
    const prefixCls = `eco-faq-win-img`;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-imgHeight-${imgHeight}`]: imgHeight,
    });
    const [selectIndex, setSelectIndex] = useState(0);
    const dataLayer_tab = dataLayerTab || {
        event: 'uaEvent',
        event_name: 'product_detail_page',
        list_name: 'none',
    };
    // 点击切换
    const itemHandle = (item: EcoFaqWithImgItemProps, index: number) => {
        if (index == selectIndex) {
            return false;
        }
        setSelectIndex(index);
        try {
            gtm.push({
                ...dataLayer_tab,
                button_name: item.title,
                __btn_id1: `${prefixCls} .item-${index + 1}`,
                __btn_id2: item.title,
                __btn_type: 'text',
            });
        } catch (error) {
            /* empty */
        }
    };
    return (
        <div className={classes}>
            <div className={`${prefixCls}-in`}>
                <div className={`${prefixCls}-l`}>
                    <div className={`${prefixCls}-l-in`}>
                        {items.map((item: EcoFaqWithImgItemProps, index: number) => {
                            if (!item.title || !item.desc) {
                                return null;
                            }
                            const itemStyle = {
                                '--item-titleColor': item.titleColor,
                                '--item-descColor': item.descColor,
                            } as React.CSSProperties;
                            return (
                                <div
                                    key={index}
                                    style={itemStyle}
                                    className={`eco-faq-win-img-item item-${index + 1}${
                                        selectIndex === index ? ' eco-faq-win-img-item-active' : ''
                                    } GtmModuleData-btn-text`}
                                    onClick={() => {
                                        itemHandle(item, index);
                                    }}
                                >
                                    <div className="eco-faq-win-img-item-title">
                                        {item.title}
                                        <EcoIconArr />
                                    </div>
                                    <div className="eco-faq-win-img-item-msg">
                                        <div className="eco-faq-win-img-item-desc">{item.desc}</div>
                                        <EcoButtonThree {...item} className={`eco-faq-win-img-item-btns`} />
                                    </div>
                                    <div className="eco-faq-win-img-item-img">
                                        <EcoImgVideo
                                            isVideo={item.isVideo}
                                            pc={item.pc}
                                            h5={item.h5}
                                            poster={item.poster}
                                            posterH5={item.posterH5}
                                            autoPlay={true}
                                            loop={true}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className={`${prefixCls}-r`}></div>
            </div>
        </div>
    );
};

export default EcoFaqWithImg;
